import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../../feature-module/core/services/modal.service';
import { DynamicModelComponent } from '../../../feature-module/core/common/dynamic-model/dynamic-model.component';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { environment } from '../../../../enviroments/environments';
import { AuthService } from '../../core/service/auth.service';
import { LoginModalComponent } from '../login-modal/login-modal.component';


@Component({
  selector: 'app-login-modal',
  templateUrl: 'register-modal.component.html',
  styleUrls: ['./register-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})

export class RegisterModalComponent implements OnInit {
  password: boolean[] = [false, false]; // Add more as needed
  signUpForm: FormGroup;

  otpData!: any;
  otp: FormControl = new FormControl('', [Validators.required, Validators.pattern(/^\d{6}$/)]); // Assuming OTP is a 6-digit number

  constructor(
    private readonly modalService: ModalService,
    private readonly _fb: FormBuilder,
    private readonly compRef: DynamicModelComponent,
    private readonly authService: AuthService
  ) {
    this.signUpForm = this._fb.group({
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required]],
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      tenantId: [environment.tenantId, [Validators.required]],
      agree: [false, [Validators.requiredTrue]],
    }, { validators: this.passwordsMatchValidator });
  }

  passwordsMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  togglePassword(index: number): void {
    this.password[index] = !this.password[index];
  }

  ngOnInit() { }

  close() {
    this.compRef.close();
  }

  openLogin() {
    this.modalService.open(LoginModalComponent).subscribe();
    this.close();
  }

  signUp() {
    this.authService.register(this.signUpForm.value).subscribe({
      next: (response: any) => {
        console.log('Registration successful:', response);
        this.otpData = response.data;
      },
      error: (error) => {
        console.error('Registration failed:', error);
      }
    });

  }

  resendOtp() {
    this.authService.resendOtp(this.otpData.otpId).subscribe({
      next: (response: any) => {
        console.log('OTP resent successfully:', response);
        this.otpData = response.data;
      },
      error: (error) => {
        console.error('Failed to resend OTP:', error);
      }
    });
  }

  verifyOtp() {
    if (!this.otp.valid) return;
    const payload = {
      otpCode: this.otp.value,
      otpId: this.otpData.otpId
    }

    this.authService.verifyOtp(payload).subscribe({
      next: (response: any) => {
        console.log('OTP verification successful:', response);
        this.openLogin();
      },
      error: (error) => {
        console.error('OTP verification failed:', error);
      }
    });
  }
}
